import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCards } from '../../actions/cards_actions.jsx';
import { withTranslation, Trans } from 'react-i18next';
import ToogleButton from '../controls/buttons/toogle_button.jsx';
import "../../resources/styles.scss";

const emptyUser = {
    applicationUserId: "00000000-0000-0000-0000-000000000000",
    userName: "",
    password: "",
    firstName: "",
    secondName: "",
    email: "",
    isActive: true,
    roleName: "Admin"
};

class EditCard extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.item) {
            this.state = { item: this.props.item, isNewUser: false };
        } else {
            this.state = {
                item: emptyUser,
                isNewCard: true,
                isFirstUser: !this.props.hasAnyUsers
            };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancelEditCard = this.cancelEditCard.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        let newState = Object.assign({}, this.state);
        newState.item.userName = this.refs.userName.value;
        newState.item.password = this.refs.password.value;
        newState.item.firstName = this.refs.firstName.value;
        newState.item.secondName = this.refs.secondName.value;
        newState.item.email = this.refs.email.value;
        newState.item.roleName = this.refs.roleName.value;
        newState.item.isActive = this.refs.isActive.state.active;
        this.setState(newState);

        if (this.state.isNewDevice) {
            this.props.addDevice(newState.item);
        } else {
            this.props.editDevice(newState.item);
        }
    }

    cancelEditDevice(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="form_container">
                <form onSubmit={this.handleSubmit}>
                    <div className="form-body">
                        <div className="left-panel">
                            <p>
                                <label><Trans>Devices.deviceImei</Trans></label>
                                <input type="text" ref="deviceImei" defaultValue={this.state.item.deviceImei} disabled={!this.state.isNewDevice} />
                            </p>
                            <p>
                                <label><Trans>Devices.name</Trans></label>
                                <input type="text" ref="name" defaultValue={this.state.item.name} />
                            </p>
                            <p>
                                <label><Trans>Devices.description</Trans></label>
                                <input type="text" ref="description" defaultValue={this.state.item.description} />
                            </p>
                            <p>
                                <label><Trans>Devices.protocolType</Trans></label>
                                <input type="text" ref="protocolType" defaultValue={this.state.item.protocolType} />
                            </p>
                            <p className="toogle-element">
                                <label><Trans>Devices.isActive</Trans></label>
                                <ToogleButton ref="isActive" defaultValue={this.state.item.isActive} />
                            </p>
                        </div>
                        <div className="right-panel">
                            <p>
                                <label><Trans>Devices.deviceIoSettings.volumeCountIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_volumeCountIoId" defaultValue={this.state.item.deviceIoSettings.volumeCountIoId} />
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.volumeRatio</Trans></label>
                                <input type="text" ref="deviceIoSettings_volumeRatio" defaultValue={this.state.item.deviceIoSettings.volumeRatio} />
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.valveIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_valveIoId" defaultValue={this.state.item.deviceIoSettings.valveIoId} />
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.userKeyIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_userKeyIoId" defaultValue={this.state.item.deviceIoSettings.userKeyIoId} />
                            </p>
                        </div>
                    </div>
                    <div className="form-buttons-container">
                        <button type="submit"><Trans>Table.saveButton</Trans></button>
                        <button onClick={this.cancelEditDevice}><Trans>Table.cancelButton</Trans></button>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let id = ownProps.match.params.id;
    return {
        item: id ? state.cards.cards.find(x => x.cardId === id) : null
    };
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        editCard: card => dispatch(actionCards.editCard(card, ownProps)),
        addCard: card => dispatch(actionCards.addCard(card, ownProps))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation("translations")(EditCard)));